import { observable } from 'rewire-core';

export type IEmployeeTimeOffTypeView = 'transactionDetails' | 'requestHistory';

interface IEmployeeTimeOffTypeViewState {
  view: IEmployeeTimeOffTypeView;
}

class EmployeeTimeOffTypeViewModel {
  state: IEmployeeTimeOffTypeViewState;

  constructor() {
    this.state = observable({view: 'transactionDetails'});
  }

  get view(): IEmployeeTimeOffTypeView {
    return this.state.view;
  }

  set view(view: IEmployeeTimeOffTypeView) {
    this.state.view = view;
  }

  handleViewButtonClick = (view: IEmployeeTimeOffTypeView) => ()    => this.view = view;
  isView                = (view: IEmployeeTimeOffTypeView): boolean => this.view === view;
}

const employeeTimeOffTypeViewModel = new EmployeeTimeOffTypeViewModel();
export default employeeTimeOffTypeViewModel;